export default "__VITE_ASSET__DGL_9zR$__"